module.exports = __webpack_public_path__ + "img/iconosilla.d2b5002f.png";